
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/list-item-decorator",
      function () {
        return require("private-next-pages/joy-ui/api/list-item-decorator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/list-item-decorator"])
      });
    }
  